import "./DecaturRemodelingPlanningGuide.module.css";
import Header from "@/reusable_sections/Header";
import PlanningGuideHero from "./sections/PlanningGuideHero";
import RemodelPlanningGuide from "./sections/RemodelPlanningGuide";
import RemodelFaq from "./sections/RemodelFaq";
import RelatedLinksAndEstimate from "./sections/RelatedLinksAndEstimate";
import Footer from "@/reusable_sections/Footer";
export default function DecaturRemodelingPlanningGuidePage() {
  return <div>
      <Header />
      <PlanningGuideHero />
      <RemodelPlanningGuide />
      <RemodelFaq />
      <RelatedLinksAndEstimate />
      <Footer />
    </div>;
}